import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, reactive } from "vue";


export default /*#__PURE__*/_defineComponent({
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  title: {
    type: String,
    required: false
  },
  message: {
    type: String,
    required: false
  },
  buttonValidateMessage: {
    type: String,
    required: false
  }
},
  emits: ["cancel", "validate"],
  setup(__props, { emit }) {

const props = __props




const state = reactive({
  isOpen: computed(() => props.isOpen)
});

return (_ctx: any,_cache: any) => {
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_modal = _resolveComponent("va-modal")!

  return (_openBlock(), _createBlock(_component_va_modal, {
    modelValue: _unref(state).isOpen,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_unref(state).isOpen = $event)),
    "hide-default-actions": "",
    title: props.title ?? _ctx.$t('activations.deactivation'),
    message: props.message ?? _ctx.$t('activations.messageModal')
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_va_button, {
        flat: "",
        outline: "",
        class: "mr-1",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cancel')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t("buttons.cancel")), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_va_button, {
        class: "ml-1",
        color: "danger",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('validate')))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(props.buttonValidateMessage ?? _ctx.$t("buttons.deactivate")), 1)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue", "title", "message"]))
}
}

})